import { createCombinedAction as cCA } from '../helpers';

export const getStorePermission = cCA({ name: 'getStorePermission', prefix: 'store@@' });
export const setStorePermission = cCA({ name: 'setStorePermission', prefix: 'store@@' });
export const deleteStorePermission = cCA({ name: 'deleteStorePermission', prefix: 'store@@' });
